/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'notification': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M64 128c7.04 0 12.8-5.907 12.8-13.126H51.2C51.2 122.093 56.896 128 64 128zm38.4-39.386V55.795c0-20.153-10.496-37.024-28.8-41.485V9.843C73.6 4.403 69.312 0 64 0c-5.312 0-9.6 4.397-9.6 9.843v4.467c-18.368 4.461-28.8 21.268-28.8 41.485v32.819l-12.8 13.127v6.566h102.4v-6.566l-12.8-13.12v-.007z"/>'
  }
})
